import React from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import SessionIndicator from '../common/SessionIndicator';
import { useCompanyStatus } from '../../hooks/useCompanyStatus';
import { useAuth } from '../../contexts/AuthContext';

const Layout = ({ children }) => {
  const { logout } = useAuth();
  
  // Monitorar status da empresa em tempo real
  useCompanyStatus();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          {children}
        </main>
      </div>
      
      {/* Indicador de sessão */}
      <SessionIndicator timeoutMinutes={30} onLogout={logout} />
    </div>
  );
};

export default Layout;